export default "__VITE_ASSET__BuWO5qMd__"